module.exports = __webpack_public_path__ + "img/DE00512.5c896ea9.png";